var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 9.49984H8.39996C8.39996 9.7581 8.56522 9.98738 8.81022 10.069L8.99996 9.49984ZM9.59996 5.33317C9.59996 5.0018 9.33133 4.73317 8.99996 4.73317C8.66859 4.73317 8.39996 5.0018 8.39996 5.33317H9.59996ZM11.3102 10.9024C11.6246 11.0072 11.9644 10.8373 12.0692 10.5229C12.174 10.2085 12.0041 9.86875 11.6897 9.76396L11.3102 10.9024ZM9.59996 9.49984V5.33317H8.39996V9.49984H9.59996ZM8.81022 10.069L11.3102 10.9024L11.6897 9.76396L9.1897 8.93063L8.81022 10.069ZM16.7333 9.49984C16.7333 13.7708 13.271 17.2332 8.99996 17.2332V18.4332C13.9337 18.4332 17.9333 14.4336 17.9333 9.49984H16.7333ZM8.99996 17.2332C4.72896 17.2332 1.26663 13.7708 1.26663 9.49984H0.066626C0.066626 14.4336 4.06622 18.4332 8.99996 18.4332V17.2332ZM1.26663 9.49984C1.26663 5.22884 4.72896 1.7665 8.99996 1.7665V0.566504C4.06622 0.566504 0.066626 4.56609 0.066626 9.49984H1.26663ZM8.99996 1.7665C13.271 1.7665 16.7333 5.22884 16.7333 9.49984H17.9333C17.9333 4.56609 13.9337 0.566504 8.99996 0.566504V1.7665Z",
    fill: "#A5AFC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.91d0f5ef8640e301c3b7dd43ed36e367.svg";
export { ForwardRef as ReactComponent };